<div class="container-fluid h-100 p-0">
  <div class="d-flex h-100">

    <div class="col-sm-12">
      <div class="row h-100 ">
        <div class="col-12 p-0 h-100">
          <div class="row h-100 m-0">
            <div class="col-12 p-0  align-self-start">
              <app-standalone-header></app-standalone-header>
            </div>
            <div class="col-12  align-self-start min-heightContent">

              <router-outlet></router-outlet>
            </div>
            <div class="col-12 align-self-end"> 
              <app-footer></app-footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>